import { PackageTypeRouteT } from "../models/models";
import CodePurchase from "../pages/CodePurchase";
import SubscriptionPurchase from "../pages/SubscriptionPurchase";
import Error from "../../../Pages/Error/Error";
import AddonPurchase from "../pages/AddonPurchase";
import PurchaseComplete from "../pages/PurchaseComplete";
import PurchaseFailed from "../pages/PurchaseFailed";
import PurchaseCheckout from "../pages/PurchaseCheckout";

/**
 * @param packageType defined in the URL
 * @returns Purchase page React Element
 */

const getPurchasePageBasedOnPackageType = (packageType: PackageTypeRouteT) => {
  switch (packageType) {
    case "business":
    case "pro":
    case "premium": {
      // Purchase default plans:
      // BUSINESS, PRO and PREMIUM
      return SubscriptionPurchase;
    }
    case "codes": // Old route name for pay-as-you-go
    case "pay-as-you-go": {
      // Purchase codes.
      // Subscriber can purchase 5, 10 or 20 codes
      // and can use it if he wants, for instance, upload more then 2GB of data
      // and he has no permissions to do this according to his plan.
      return CodePurchase;
    }
    case "sub-users":
    case "extra-storage": {
      // ADDON
      // Purchase extra storage additional to current Subscriber plan
      // and additional sub-user licenses if the current Subscriber is top user.
      return AddonPurchase;
    }

    case "checkout": {
      // This page represents the 3rd step of the purchase process
      // and it skips if user not selected new credit card payment method.
      return PurchaseCheckout;
    }

    // Next cases works as usual routing
    // and the packageType actually is not a purchase type here
    // and just usual route.
    //
    // This logic was implemented before and I decided not to change it
    // in order to have back compatibility.
    case "purchase-complete":
    case "purchase-result":
    case "purchase-downgrade-success":
      return PurchaseComplete;
    case "purchase-failed":
      return PurchaseFailed;

    default: {
      // Page not found
      return Error;
    }
  }
};

export default getPurchasePageBasedOnPackageType;
